<dcr-inline-icon-button icon="navigation:close" (click)="clearElement()" class="close"></dcr-inline-icon-button>

<div class="headline"> Je kan meer met cookies! </div>

@if (errormessage) {
  <p class="errors">{{ errormessage }}</p>
}

<div class="block">
  <div class="title">Functionele cookies</div>
  <p>
    Functionele cookies zorgen ervoor dat de basisfunctionaliteit van de website werkt. Daarom staan deze altijd aan.
  </p>
  <p>
    Meer info hierover vind je <a [href]="linkcookies">{{ linkCookiesLabel }}.</a>
  </p>
</div>

@if (cookies$ | async; as cookies) {
  <div class="block">
    <div class="title">Bijkomende cookies</div>
    <div class="items">
      <dcr-checkbox
        label="Voorkeuren"
        [checked]="cookies.preferences ? true : false"
        (change)="setConsentValue('preferences', $event)"
      ></dcr-checkbox>
      <dcr-checkbox
        label="Marketing"
        [checked]="cookies.marketing ? true : false"
        (change)="setConsentValue('marketing', $event)"
      ></dcr-checkbox>
      <dcr-checkbox
        label="Statistieken"
        [checked]="cookies.statistics ? true : false"
        (change)="setConsentValue('statistics', $event)"
      ></dcr-checkbox>
      <dcr-checkbox
        label="Sociale media / derde partij"
        [checked]="cookies.social_media ? true : false"
        (change)="setConsentValue('social_media', $event)"
      ></dcr-checkbox>
    </div>
    <div class="actions">
      <dcr-outline-button label="Functionele cookies aanvaarden" (click)="setCookies('minimal')"></dcr-outline-button>
      <dcr-filled-button
        [label]="cookieStatus === 'current' ? 'Huidige selectie aanvaarden' : 'Alle cookies aanvaarden'"
        (click)="setCookies()"
      ></dcr-filled-button>
    </div>
  </div>
}
